import React from 'react';
import { Typography } from '@common-ui/ui';
import { getDateTimeFromMillisecondsTZ } from '../../utils/dateFormatter';
import './styles.css';

const WorkItemTextNotes = ({ imageInfo }) => {
  const textNotes = imageInfo?.imageJSON?.notes;
  return (
    <>
      {textNotes && textNotes.length > 0 && (
        <div>
          <Typography variant="h5" className="workItem__header">
            NOTES
          </Typography>
          <div>
            {textNotes &&
              textNotes.length &&
              textNotes.map((comment, index) => (
                <div key={index} className="workItemTextNote__body">
                  <Typography>{comment.text}</Typography>
                  <Typography className="workItemTextNote__date">
                    {getDateTimeFromMillisecondsTZ(comment.date, comment?.timezone)}
                  </Typography>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default WorkItemTextNotes;
